export default {
  'pages.orderList.title': 'Intent list',
  'pages.orderList.search.id': 'Intent No.',
  'pages.orderList.search.id.placeholder': 'Please enter the Intent No.',
  'pages.orderList.search.name': 'Spu name',
  'pages.orderList.search.name.placeholder':
    'Please enter the spu name or spu no.',
  'pages.orderList.search.date': 'Order time',
  'pages.orderList.search.date.placeholder1': 'Please select start time',
  'pages.orderList.search.date.placeholder2': 'Please select end time',
  'pages.orderList.header.info': 'Spu information',
  'pages.orderList.header.craft': 'Craft',
  'pages.orderList.header.color': 'Color',
  'pages.orderList.header.quantity': 'Quantity',
  'pages.orderList.list.id': 'Intent No.',
  'pages.orderList.list.date': 'Order time',
  'pages.orderList.list.person': 'Order person',
};
